<template>
	<div v-if="!chooseCenterStage" class="min-h-full w-full flex flex-col">
		<div v-if="isTeacher" class="flex-1 flex justify-center w-full py-8">
			<div class="_login w-max my-auto mx-10">
				<div class="flex flex-col items-center text-center">
					<img
						src="@/assets/images/illustrations/sent.png"
						alt=""
						height="150"
						width="150"
					/>
					<div class="text-33 font-bold text-neutral-700 my-8">
						Không thể tự đăng ký tài khoản Trị liệu viên
					</div>
					<p class="text-lg text-neutral-600">
						Chúng tôi rất tiếc vì tài khoản trị liệu viên chỉ có thể
						được tạo bởi giám đốc hoặc quản lý cơ sở.
					</p>
					<p class="text-lg text-neutral-600 mt-6">
						Vui lòng liên hệ quản lý của bạn để được mời vào cơ sở
						và nhận email kích hoạt tài khoản trên Luca Education.
					</p>
				</div>
				<div class="my-12">
					<button
						type="button"
						class="button-p btn--lg w-max mx-auto"
						@click="isTeacher = false"
					>
						Quay lại đăng nhập
					</button>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="flex-1 flex justify-center w-full py-8">
				<div class="_login _page-view w-full my-auto">
					<div class="text-33 font-bold mb-1 text-neutral-700">
						Xin chào!
					</div>
					<div class="text-lg mb-12 text-neutral-600">
						Chúc thầy cô một ngày làm việc tốt lành
					</div>
					<div class="_page-view__content">
						<div class="mb-12">
							<div class="input-group input--lg">
								<div class="input-group__label">Email</div>
								<input
									type="email"
									placeholder="Địa chỉ email"
									class="bg-white"
									v-model="loginData.username"
								/>
							</div>
						</div>
						<div>
							<div class="input-group input--lg relative">
								<div
									class="input-group__label text-neutral-600"
								>
									Mật khẩu
								</div>
								<input
									:type="typePassword"
									placeholder="Mật khẩu của bạn"
									class="bg-white"
									v-model="loginData.password"
									style="padding-right: 20px"
								/>
								<div
									class="absolute right-4 top-1/2 pt-1 cursor-pointer text-neutral-600"
								>
									<svg
										height="16px"
										aria-hidden="true"
										focusable="false"
										data-prefix="fas"
										data-icon="eye"
										class="svg-inline--fa fa-eye fa-w-18"
										role="img"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 576 512"
										v-if="typePassword === 'text'"
										@click="typePassword = 'password'"
									>
										<path
											fill="currentColor"
											d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
										></path>
									</svg>
									<svg
										height="16px"
										aria-hidden="true"
										focusable="false"
										data-prefix="fas"
										data-icon="eye-slash"
										class="svg-inline--fa fa-eye-slash fa-w-20"
										role="img"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 640 512"
										v-if="typePassword === 'password'"
										@click="typePassword = 'text'"
									>
										<path
											fill="currentColor"
											d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
										></path>
									</svg>
								</div>
							</div>
						</div>
						<div class="pt-4" style="min-height: 46px">
							<div
								v-if="Error && Error?.length > 0"
								class="error text-sienna-600"
							>
								{{ Error }}
							</div>
						</div>
						<div class="flex justify-end pt-4">
							<router-link
								class="forgot-password"
								:to="{ name: routerName.FORGOT_PASSWORD }"
							>
								Quên mật khẩu?
							</router-link>
						</div>
						<div class="my-12">
							<button
								type="button"
								class="button-p btn--lg"
								@click="onSubmit"
							>
								Đăng nhập
							</button>
						</div>
						<div class="relative mb-4">
							<div
								class="absolute inset-0 flex items-center"
								aria-hidden="true"
							>
								<div
									class="w-full border-t border-neutral-300"
								/>
							</div>
							<div class="relative flex justify-center">
								<div
									class="bg-body px-2 text-neutral-600 whitespace-nowrap items-center text-sm"
								>
									Chưa có tài khoản?
								</div>
							</div>
						</div>
						<div
							@click="redirectToRegister"
							class="flex items-center justify-center bg-white px-5 py-3 rounded cursor-pointer text-neutral-600 font-semibold text-sm mb-4 shadow-sm border border-transparent hover:border-yellow-500"
						>
							Đăng ký trải nghiệm
						</div>
						<div
							@click="isTeacher = true"
							class="flex items-center justify-center bg-white px-5 py-3 rounded cursor-pointer text-neutral-600 font-semibold text-sm shadow-sm border border-transparent hover:border-yellow-500"
						>
							Bạn là trị liệu viên?
						</div>
					</div>
				</div>
			</div>
			<div
				class="text-neutral-500 font-medium text-center w-full flex items-center gap-3 justify-center py-6 flex-shrink-0"
			>
				<div>
					<img
						class="w-6 h-6"
						src="@/assets/images/icons/bulb.png"
						alt=""
					/>
				</div>
				<div>
					Tìm hiểu
					<a
						href="https://wiki.luca.education/cac-ban-cap-nhat/website"
						class="font-semibold text-green-500"
						>tính năng mới</a
					>
				</div>
			</div>
		</div>
	</div>
	<div
		class="_choose-center h-screen w-screen md-down:px-10 px-24 py-30"
		v-else
	>
		<div class="search-input w-full xl:max-w-lg mt-4">
			<div class="input-group">
				<input
					type="text"
					placeholder="Tìm kiếm trung tâm"
					class="bg-white input-with-icon"
					v-model="searchQuery"
					@keyup="searching"
					@keypress.enter="search"
				/>
				<div class="input-icon absolute top-1/2">
					<DaIcon
						name="das--search"
						class="h-4 w-4 text-neutral-400"
					/>
				</div>
			</div>
		</div>
		<div
			class="_choose-center__list grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-x-10 pb-40 mt-8"
		>
			<div v-for="org in orgList" :key="org.org_id" class="w-full mb-10">
				<ChooseCenterCard
					:data-org="org"
					@submit="selectOrg(org)"
					class="h-full"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { Options, setup, Vue } from 'vue-class-component';
import { useLogin } from './services/login';
import { _var } from '@/enums/Common';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { _ROUTER_NAME } from '@/enums';
import ChooseCenterCard from '@/components/elements/cards/chooseCenterCard/ChooseCenterCard.vue';

@Options({
	name: 'Login',
	components: { ChooseCenterCard, DaIcon },
})
export default class Login extends Vue {
	//----------------------- 🤍 Data 🤍 -----------------------//
	chooseCenterStage = false;
	errorLogin = '';
	orgs = [];
	orgList = [];
	loginData = {
		username: '',
		password: '',
	};
	typePassword = 'password';
	typing = null;
	searchQuery = '';
	isTeacher = false;

	//----------------------- 🤍 Setup 🤍 -----------------------//
	setup = setup(() => {
		const { error, loading, login } = useLogin();
		return { error, loading, login };
	});

	//**------------------------------------------ Getters ------------------------------------------**\\
	get routerName() {
		return _ROUTER_NAME;
	}

	get Error() {
		let error = this.setup.error;
		if (this.errorLogin) {
			error = this.errorLogin;
		}
		if (error && typeof error == 'object') {
			return error.join('<br/>');
		}
		return error;
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	async onSubmit() {
		try {
			this.errorLogin = '';
			const data = await this.setup.login({
				email: this.loginData.username,
				password: this.loginData.password,
			});

			if (data && data?.data) {
				localStorage.setItem(_var.TOKEN, data?.data?.access_token);
				if (data?.data?.orgs) {
					if (data?.data?.orgs.length === 1) {
						localStorage.setItem(
							_var.SUBDOMAIN,
							data?.data?.orgs[0].subdomain
						);
						return (window.location.href = '/');
					} else if (data?.data?.orgs.length <= 0) {
						return (this.errorLogin =
							'Bạn không có trung tâm nào trong danh sách');
					} else {
						this.chooseCenterStage = true;
						this.orgs = data?.data?.orgs;
						this.orgList = data?.data?.orgs;
					}
				}
			}
		} catch (e) {
			console.log(e);
		}
	}

	selectOrg(org) {
		localStorage.setItem(_var.SUBDOMAIN, org.subdomain);
		return (window.location.href = '/');
	}

	searching() {
		clearInterval(this.typing);
		this.typing = setTimeout(() => {
			this.search();
		}, 0);
	}

	async search() {
		this.orgList = this.orgs.filter((s) => {
			return (
				this.formatTextSearch(s.address).includes(
					this.formatTextSearch(this.searchQuery)
				) ||
				this.formatTextSearch(s.name).includes(
					this.formatTextSearch(this.searchQuery)
				) ||
				this.formatTextSearch(s.subdomain).includes(
					this.formatTextSearch(this.searchQuery)
				)
			);
		});
	}

	formatTextSearch(text) {
		if (!text) {
			return '';
		}
		return text.toLowerCase();
	}

	redirectToRegister() {
		console.log(process.env.VUE_APP_REGISTER_URL)
		window.location.href = process.env.VUE_APP_REGISTER_URL;
	}
}
</script>
